module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('toolbar', {
    attrs: {
      "activeNote": _vm.activeNote
    },
    on: {
      "addNote": _vm.addNote,
      "toggleFavorite": _vm.toggleFavorite,
      "deleteNote": _vm.deleteNote
    }
  }), _vm._v(" "), _c('notes-list', {
    attrs: {
      "notes": _vm.notes,
      "activeNote": _vm.activeNote
    },
    on: {
      "updateActiveNote": _vm.updateActiveNote
    }
  }), _vm._v(" "), _c('editor', {
    attrs: {
      "activeNote": _vm.activeNote
    },
    on: {
      "edit": _vm.edit
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-cde89eea"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/App.vue
// module id = 11
// module chunks = 0